<template>
  <a-modal
    :title="title"
    :width="640"
    :visible="visible"
    :confirmLoading="confirmLoading"
    :maskClosable="false"
    @cancel="handleCancel"
  >
    <a-spin :spinning="confirmLoading">
      <a-form-item
        v-show="false"
        label="id"
        :hidden="true"
        :labelCol="labelCol"
        :wrapperCol="wrapperCol"
      >
        <a-input
          v-decorator="['id']"
          :disabled="showable"
        />
      </a-form-item>
      <a-form :form="form">
        <a-form-item
          label="主键"
          :hidden="true"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <a-input
            :disabled="showable"
            v-decorator="['id', {rules: [{required: false, message: '请输入id'}]}]" />
        </a-form-item>
        <a-form-item
          label="类别"
          :hidden="linkable"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <a-input
            :disabled="showable"
            v-decorator="['category', {rules: [{required: false, message: '请输入类别'}]}]"
            placeholder="请输入类别"
          />
        </a-form-item>
        <a-form-item
          label="名称"
          :hidden="linkable"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol">
          <a-input
            :disabled="showable"
            v-decorator="['name', {rules: [{required: false, message: '请输入名称'}]}]"
            placeholder="请输入名称"
          >
          </a-input>
        </a-form-item>
        <a-form-item
          label="规格"
          :hidden="linkable"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol">
          <a-input
            :disabled="showable"
            v-decorator="['format', {rules: [{required: false, message: '请输入规格'}]}]"
            placeholder="请输入规格"
          >
          </a-input>
        </a-form-item>
        <a-form-item
          label="单位"
          :hidden="linkable"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol">
          <a-input
            :disabled="showable"
            placeholder="请输入单位"
            v-decorator="['unit', {rules: [{required: false, message: '请输入单位'}]}]"
          >
          </a-input>
        </a-form-item>
        <a-form-item
          label="落地单价"
          :hidden="linkable"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol">
          <a-input-number
            :precision="3"
            style="width: 100%"
            :min="0"
            :disabled="showable"
            placeholder="请输入落地单价"
            v-decorator="['price', {rules: [{required: false, message: '请输入落地单价'}]}]"
          >
          </a-input-number>
        </a-form-item>
        <a-form-item
          label="苗源及质量标准"
          :hidden="linkable"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol">
          <a-textarea
            :rows="4"
            :disabled="showable"
            placeholder="请输入苗源及质量标准"
            v-decorator="['remark', {rules: [{required: false, message: '请输入苗源及质量标准'}]}]"/>
        </a-form-item>
      </a-form>
    </a-spin>
    <template slot="footer" >
      <div v-show="editable || addable || linkable">
        <a-button key="cancel" @click="handleCancel">取消</a-button>
        <a-button key="forward" :loading="confirmLoading" type="primary" @click="handleOk">保存</a-button>
      </div>
    </template>
  </a-modal>
</template>

<script>
import moment from 'moment'
import pick from 'lodash.pick'
import { FormMixin } from '@/mixins/FormMixin'
import { addObj, getObj, putObj } from '@/api/common/SxTree'

export default {
  name: 'SxTreeAddOrUpdate',
  mixins: [FormMixin],
  data () {
    return {
      confirmLoading: false,
      form: this.$form.createForm(this),
      showable: false
    }
  },
  methods: {
    edit (id, type) {
      this.list = []
      this.visible = true
      const { form: { setFieldsValue, resetFields } } = this
      if (['edit', 'show', 'link', 'removeLink'].includes(type)) {
        this.confirmLoading = true
        getObj(id).then(res => {
          const record = res.data
          record.date = moment(record.date)
          this.confirmLoading = false
          this.$nextTick(() => {
            setFieldsValue(pick(record, ['id', 'category', 'name', 'format', 'unit', 'price', 'remark']))
          })
        })
      } else {
        resetFields()
      }
    },
    handleOk () {
      this.form.validateFields(async (err, values) => {
        if (!err) {
          this.confirmLoading = true
          try {
            if (this.type === 'add') {
              await addObj(values)
            } else if (this.type === 'edit') {
              await putObj(values)
            }
            setTimeout(() => {
              this.confirmLoading = false
              this.$emit('ok')
              this.handleCancel()
            }, 1500)
          } catch (e) {
            this.confirmLoading = false
            this.$message.error(e.msg)
          }
        }
      })
    }
  }
}
</script>

<style scoped>

</style>
